export default {
    route: {
        hidden: true,
        meta: {
            title: '订单列表',
            auth: "sign",
        }
    }
}
